import React from "react";
import DatePicker from "react-datepicker";

const TIME_PATTERN = /^(\d{1,2}):(\d{2})/;

const pad = (value) => String(value).padStart(2, "0");

// El valor se conserva en formato "HH:mm" (24 horas); solo la vista usa 12 horas.
const toDate = (value) => {
  const match = TIME_PATTERN.exec(value || "");
  if (!match) return null;

  const date = new Date();
  date.setHours(Number(match[1]), Number(match[2]), 0, 0);
  return date;
};

const toValue = (date) =>
  date ? `${pad(date.getHours())}:${pad(date.getMinutes())}` : "";

/**
 * Selector de hora con formato fijo de 12 horas (AM/PM), independiente
 * de la configuración regional del navegador.
 */
export default function TimeInput12h({
  value,
  onChange,
  disabled = false,
  placeholder = "--:-- --",
  timeIntervals = 15,
  className = "",
}) {
  return (
    <DatePicker
      selected={toDate(value)}
      onChange={(date) => onChange(toValue(date))}
      showTimeSelect
      showTimeSelectOnly
      timeIntervals={timeIntervals}
      timeCaption="Hora"
      dateFormat="hh:mm aa"
      timeFormat="hh:mm aa"
      placeholderText={placeholder}
      disabled={disabled}
      className={`form-control ${className}`.trim()}
      wrapperClassName="time-input-12h"
      popperClassName="time-input-12h-popper"
      portalId="time-input-12h-portal"
    />
  );
}
